import type { InjectionKey } from 'vue';
// eslint-disable-next-line local-rules/no-vuex-store
import { useStore as baseUseStore, type Store } from 'vuex';
import type { AssessmentState } from '@/modules/assessment/store/mutations';
import type { State as FrameworkState } from '@/modules/framework/storeDeprecated';
import type { EmergingThreatsCommonState } from '@/modules/emerging-threats-common/store/mutations';
import type { ActionCentreState } from '@/modules/action-centre/store';

export type State = {
  assessment: AssessmentState;
  framework: FrameworkState;
  actionCentre: ActionCentreState;
  emergingThreatsCommon: EmergingThreatsCommonState;
  legacy: {
    countries: {
      all: { name: string; code: string }[];
    };
    [name: string]: any;
  };
  [name: string]: any;
};

export const storeInjectionKey: InjectionKey<Store<State>> = Symbol('vuex-store');

// A partially typed `useStore`
export const useStore = () => baseUseStore(storeInjectionKey);
